import { __extends } from "tslib";
import { TransformNode } from "@babylonjs/core/Meshes/transformNode";
import { SceneElement } from "./SceneElement";
/**
 * TODO: This is only a placeholder for now. The final implementation is following later.
 */
var GroupElement = /** @class */ (function (_super) {
    __extends(GroupElement, _super);
    function GroupElement(pModel) {
        var _this = _super.call(this, pModel, new TransformNode("", pModel.scene)) || this;
        _this.mChildElements = new Array();
        return _this;
    }
    Object.defineProperty(GroupElement.prototype, "childElements", {
        get: function () {
            return (this.mChildElements);
        },
        enumerable: false,
        configurable: true
    });
    return GroupElement;
}(SceneElement));
export { GroupElement };
